import classnames from 'classnames';
import React, { Component } from 'react';
import { connect } from 'react-redux';
//style
import './styles.css';

class ActivationNavListNewAccount extends Component {
  splitVal = (str) => {
    return (str.split(":")).pop();
  }
  callPopup = (event, tempRefId) => {
    var id = event.target.id;
    var name = event.target.name;
    var type = event.target.value;
    var title = event.target.title
    this.props.callPopup(id, name, type, title, tempRefId);
  }

  handleEditClick = (e, tempRefId) => {
    var id = e.target.id;
    var type;
    if (e.target.title === 'ACH Credit') {
      type = 'achCredit';
    } else {
      type = e.target.title;
    }
    this.props.callEditClick(id, type, tempRefId);
  }

  getProductRelatedTaxonomy(products, countryList) {
    if (products !== undefined) {
      products = products.map(item => {
        countryList.filter(countItem => {
          if ('country' in item) {
            if (countItem.id === item.country.value) {
              item.country.name = countItem.name
              if (item.accountType !== undefined) {
                countItem.associations.filter(accountType => {
                  if (accountType.id === item.accountType.value) {
                    item.accountType.name = accountType.name
                  }
                })
              }
            }
          }
        });
        return item;
      });
      return products;
    }
  }

  renderActivation = () => {
    var element = [];
    var listdata = this.props._data;
    var accountListData = this.props.countryList !== undefined
      ? this.getProductRelatedTaxonomy(listdata.account, this.props.countryList) : listdata.account;
    var echannelListData = this.props.productCountryList !== undefined
      ? this.getProductRelatedTaxonomy(listdata.echannel, this.props.productCountryList) : listdata.echannel;
    var achListData = this.props.productCountryList !== undefined
      ? this.getProductRelatedTaxonomy(listdata.achCredit, this.props.productCountryList) : listdata.achCredit;
    var ccListData = this.props.achCountryList !== undefined
      ? this.getProductRelatedTaxonomy(listdata.corporateCard, this.props.productCountryList) : listdata.corporateCard;
    const cffListData = this.props.achCountryList !== undefined
      ? this.getProductRelatedTaxonomy(listdata.cashFlow, this.props.productCountryList) : listdata.cashFlowForecasting;

    for (let i = 0; accountListData.length > i; i++) {
      if (this.props.type === "account") {
        let accountList = accountListData[i];
        element.push(
          <div className={classnames({
            "gdoc-activation-newaccount-navlist": true,
            "block": this.props.caseMenu.isEditing
          })} key={accountList.id}>
            <div className="gdoc-activation-details">
              <div className="gdocs-float-left gdocs-paddtop">
                <div className='gdoc-activation-listhead gdocs-float-left'>
                  {`${accountList.accountType.name}, ${accountList.country.name},  ${accountList.currency.name}`}
                </div>
                <div className="icon icon-chevron-right iconCenter"></div>
                <div className="gdocs-clear-float"></div>
                <div className='gdoc-activation-desc'>
                  {`${accountList.accountHolder.name} ${accountList.accountTitle !== undefined ? accountList.accountTitle : (accountList.tempRefrenceId)}`}</div>
              </div>
              <div className="gdocs-float-right">
                {(this.splitVal(accountList.status) === 'inactive') ? <div>
                  <div className="gdocs-pendding-activation">{this.props._pendingActivation}</div>
                  {
                    !this.props.customer &&
                    <div className="gdocs-activation-btn">
                      <button value="account" id={accountList.id} title={accountList.tempRefrenceId} name={accountList.accountType.name} onClick={this.callPopup.bind(accountList.tempRefrenceId)}>
                        {this.props.translations(this.props._accountActivationModalPageJson.par.modal_activated.text)}</button>
                    </div>
                  }</div> : <div>
                  <div className="gdoc-activation-info gdocs-paddtop gdocs-float-left">
                    <div><span>{this.props.translateWord(this.props._pageJson.par.status_block_newAccounts.fieldLabels)[0]}</span>
                      <span className="gdocs-paddleft">{accountList.accountNumber === '' ? 'Live' : accountList.accountNumber}</span></div>
                    <div><span>{this.props.translateWord(this.props._pageJson.par.status_block_newAccounts.fieldLabels)[1]}</span><span className="gdocs-paddleft">{accountList.branchCode === '' ? 'Live' : accountList.branchCode}</span></div>
                    <div><span>{this.props.translateWord(this.props._pageJson.par.status_block_newAccounts.fieldLabels)[2]}</span><span className="gdocs-paddleft">{accountList.activationDate}</span></div>
                  </div>
                  {
                    !this.props.customer &&
                    <div className="icon icon-edit gdocs-float-left gdoc-editicon" title="account" id={accountList.id} onClick={(e) => this.handleEditClick(e, accountList.tempRefrenceId)}></div>
                  }
                  <div className="gdoc-activation-listseparator gdocs-float-left"></div>
                  <div className="gdoc-activation-status gdocs-float-left">{(this.splitVal(accountList.status))}</div>
                  <div className="icon icon-circle-confirmation-solid iconSigned"></div>
                </div>}
              </div>
              <div className="gdocs-clear-float"></div>
            </div>
          </div>
        )
      }
    }
    for (let i = 0; echannelListData.length > i; i++) {
      if (this.props.type === "echannel") {
        let echannelList = echannelListData[i];
        element.push(<div className={classnames({
          "gdoc-activation-newaccount-navlist": true,
          "block": this.props.caseMenu.isEditing
        })} key={echannelList.id}>
          <div className="gdoc-activation-details">
            <div className="gdocs-float-left gdocs-paddtop">
              <div className='gdoc-activation-listhead gdocs-float-left'>
                {`${echannelList.eChannelType.name}, ${echannelList.country.name}, ${(echannelList.newEchannel === true) ? this.props.newEchannelKey : this.props.existingEchannelKey}`}
              </div>
              <div className="icon icon-chevron-right iconCenter"></div>
              <div className="gdocs-clear-float"></div>
              <div className='gdoc-activation-desc'>
                {`${echannelList.profileOwner.name} (${echannelList.newEchannel ? `${echannelList.tempRefrenceId}` : ''})`}
              </div>
            </div>
            <div className="gdocs-float-right">
              {(this.splitVal(echannelList.status) === 'inactive') ? <div>
                <div className="gdocs-pendding-activation">{this.props._pendingActivation}</div>
                {
                  !this.props.customer &&
                  <div className="gdocs-activation-btn">
                    <button value="echannel" id={echannelList.id} name={echannelList.eChannelType.name} title={echannelList.tempRefrenceId} onClick={this.callPopup.bind(echannelList.tempRefrenceId)}>
                      {this.props.translations(this.props._echannelActivationModalPageJson.par.button_activatedEchannel.text)}</button>
                  </div>
                }
              </div> : <div>
                <div className="gdoc-activation-info gdocs-paddtop gdocs-float-left">
                  <div><span>{this.props.translateWord(this.props._pageJson.par.status_block_echannels.fieldLabels)[0]}</span><span className="gdocs-paddleft">{echannelList.iscmp = true && echannelList.eChannelId === undefined ? 'Live' : echannelList.eChannelId}</span></div>
                  <div><span>{this.props.translateWord(this.props._pageJson.par.status_block_echannels.fieldLabels)[1]}</span><span className="gdocs-paddleft">{echannelList.activationDate}</span></div>
                </div>
                {
                  !this.props.customer &&
                  <div className="icon icon-edit gdocs-float-left gdoc-editicon" title="echannel" id={echannelList.id} onClick={(e) => this.handleEditClick(e, echannelList.tempRefrenceId)}></div>
                }
                <div className="gdoc-activation-listseparator gdocs-float-left"></div>
                <div className="gdoc-activation-status gdocs-float-left">{(this.splitVal(echannelList.status))}</div>
                <div className="icon icon-circle-confirmation-solid iconSigned"></div>
              </div>}
            </div>
            <div className="gdocs-clear-float"></div>
          </div>
        </div>
        )
      }
    }

    for (let i = 0; achListData.length > i; i++) {
      if (this.props.type === "achCredit") {
        let achList = achListData[i];
        element.push(<div className={classnames({
          "gdoc-activation-newaccount-navlist": true,
          "block": this.props.caseMenu.isEditing
        })} key={achList.id}>
          <div className="gdoc-activation-details">
            <div className="gdocs-float-left gdocs-paddtop">
              <div className='gdoc-activation-listhead gdocs-float-left'>
                {`${achList.country.name}`}
              </div>
              <div className="icon icon-chevron-right iconCenter"></div>
              <div className="gdocs-clear-float"></div>
              <div className='gdoc-activation-desc'>{achList.achAgent.name}</div>
            </div>
            <div className="gdocs-float-right">
              {(this.splitVal(achList.status) === 'inactive') ? <div>
                <div className="gdocs-pendding-activation">{this.props._pendingActivation}</div>
                {
                  !this.props.customer &&
                  <div className="gdocs-activation-btn">
                    <button value="achCredit" id={achList.id} name={achList.id} onClick={this.callPopup.bind()}>
                      {this.props.translations(this.props._achActivationModalPageJson.par.button_activatedAch.text)}</button>
                  </div>
                }
              </div> : <div>
                <div className="gdoc-activation-info gdocs-paddtop gdocs-float-left">
                  <div><span>{this.props.translateWord(this.props._pageJson.par.status_block_achCredits.fieldLabels)[0]}</span><span className="gdocs-paddleft">{achList.iscmp = true && achList.achId === undefined ? 'Live' : achList.achId}</span></div>
                  <div><span>{this.props.translateWord(this.props._pageJson.par.status_block_achCredits.fieldLabels)[1]}</span><span className="gdocs-paddleft">{achList.activationDate}</span></div>
                </div>
                {
                  !this.props.customer &&
                  <div className="icon icon-edit gdocs-float-left gdoc-editicon" title="ACH Credit" id={achList.id} onClick={this.handleEditClick}></div>
                }
                <div className="gdoc-activation-listseparator gdocs-float-left"></div>
                <div className="gdoc-activation-status gdocs-float-left">{(this.splitVal(achList.status))}</div>
                <div className="icon icon-circle-confirmation-solid iconSigned"></div>
              </div>}
            </div>
            <div className="gdocs-clear-float"></div>
          </div>
        </div>
        )
      }
    }

    for (let i = 0; ccListData.length > i; i++) {
      if (this.props.type === "corporateCard") {
        let ccList = ccListData[i];
        element.push(<div className={classnames({
          "gdoc-activation-newaccount-navlist": true,
          "block": this.props.caseMenu.isEditing
        })} key={ccList.id}>
          <div className="gdoc-activation-details">
            <div className="gdocs-float-left gdocs-paddtop">
              <div className='gdoc-activation-listhead gdocs-float-left'>
                {`${ccList.country.name}`}
              </div>
              <div className="icon icon-chevron-right iconCenter"></div>
              <div className="gdocs-clear-float"></div>
              <div className='gdoc-activation-desc'>{ccList.corporateCardAgent.name}</div>
            </div>
            <div className="gdocs-float-right">
              {(this.splitVal(ccList.status) === 'inactive') ? <div>
                <div className="gdocs-pendding-activation">{this.props._pendingActivation}</div>
                {
                  !this.props.customer &&
                  <div className="gdocs-activation-btn">
                    <button value="corporateCard" id={ccList.id} name={ccList.id} onClick={this.callPopup.bind()}>
                      {this.props.translations(this.props._ccActivationModalPageJson.par.button_activatedCorporateCard.text)}</button>
                  </div>
                }
              </div> : <div>
                <div className="gdoc-activation-info gdocs-paddtop gdocs-float-left">
                  <div><span>{this.props.translateWord(this.props._pageJson.par.status_block_corporateCard.fieldLabels)[0]}</span><span className="gdocs-paddleft">{ccList.iscmp = true && ccList.corporateCardId === undefined ? 'Live' : ccList.corporateCardId}</span></div>
                  <div><span>{this.props.translateWord(this.props._pageJson.par.status_block_corporateCard.fieldLabels)[1]}</span><span className="gdocs-paddleft">{ccList.activationDate}</span></div>
                </div>
                {
                  !this.props.customer &&
                  <div className="icon icon-edit gdocs-float-left gdoc-editicon" title="corporateCard" id={ccList.id} onClick={this.handleEditClick}></div>
                }
                <div className="gdoc-activation-listseparator gdocs-float-left"></div>
                <div className="gdoc-activation-status gdocs-float-left">{(this.splitVal(ccList.status))}</div>
                <div className="icon icon-circle-confirmation-solid iconSigned"></div>
              </div>}
            </div>
            <div className="gdocs-clear-float"></div>
          </div>
        </div>
        )
      }
    }
    for (let i = 0; cffListData.length > i; i++) {
      if (this.props.type === "cashFlowForecasting") {
        let cffList = cffListData[i];
        element.push(<div className={classnames({
          "gdoc-activation-newaccount-navlist": true,
          "block": this.props.caseMenu.isEditing
        })} key={cffList.id}>
          <div className="gdoc-activation-details">
            <div className="gdocs-float-left gdocs-paddtop">
              <div className='gdoc-activation-listhead gdocs-float-left'>
                {`${cffList.country.name}`}
              </div>
              <div className="icon icon-chevron-right iconCenter"></div>
              <div className="gdocs-clear-float"></div>
              <div className='gdoc-activation-desc'>{cffList.cffAgent.name}</div>
            </div>
            <div className="gdocs-float-right">
              {(!cffList.activationDate) ?
                <div>
                  <div className="gdocs-pendding-activation">{this.props._pendingActivation}</div>
                  {
                    !this.props.customer &&
                    <div className="gdocs-activation-btn">
                      <button value="cashFlowForecasting" id={cffList.id} name={cffList.id} onClick={this.callPopup.bind()}>
                        {this.props.translations(this.props._ccActivationModalPageJson.par.button_activatedCorporateCard.text)}</button>
                    </div>
                  }
                </div> :
                <div>
                  <div className="gdoc-activation-info gdocs-paddtop gdocs-float-left">
                    <div><span>{this.props.translateWord(this.props._pageJson.par.status_block_cashFlowForecasting.fieldLabels)[0]}</span><span className="gdocs-paddleft">{cffList.cffId || "Not provided"}</span></div>
                    <div><span>{this.props.translateWord(this.props._pageJson.par.status_block_cashFlowForecasting.fieldLabels)[1]}</span><span className="gdocs-paddleft">{cffList.activationDate}</span></div>
                  </div>
                  {
                    !this.props.customer &&
                    <div className="icon icon-edit gdocs-float-left gdoc-editicon" title="cashFlowForecasting" id={cffList.id} onClick={this.handleEditClick}></div>
                  }
                  <div className="gdoc-activation-listseparator gdocs-float-left"></div>
                  <div className="gdoc-activation-status gdocs-float-left">{(this.splitVal(cffList.status))}</div>
                  <div className="icon icon-circle-confirmation-solid iconSigned"></div>
                </div>}
            </div>
            <div className="gdocs-clear-float"></div>
          </div>
        </div>
        )
      }
    }
    return element;
  }

  render() {
    return (
      <div>{this.renderActivation()}</div>
    );
  }
}

const mapStateToProps = state => {
  return {
    customer: state.auth.userDetails.roleDetails.customer,
    caseMenu: state.caseMenuInfo
  }
}
export default connect(mapStateToProps, null)(ActivationNavListNewAccount);



// WEBPACK FOOTER //
// ./src/components/CaseBody/Activation/ActivationNavListNewAccount/ActivationNavListNewAccount.js